const toError = (error: unknown): Error | undefined => {
  if (error instanceof Error) {
    return error;
  }
  if (error != null) {
    try {
      return new Error(JSON.stringify(error));
    } catch {
      return new Error(String(error));
    }
  }
  return undefined;
};

export { toError };
